"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var StackColumn = /** @class */ (function (_super) {
    tslib_1.__extends(StackColumn, _super);
    function StackColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StackColumn.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'stackColumn';
        _super.prototype.createLayers.call(this, layerProps);
    };
    StackColumn.getDefaultOptions = layer_1.default.getDefaultOptions;
    return StackColumn;
}(plot_1.default));
exports.default = StackColumn;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/stack-column/index.js
// module id = 982
// module chunks = 37